import React from 'react';
import { ArrowRight } from 'react-feather';
import colors from '../../../theme/colors';

/**
 * Funciones puras para el formulario de búsqueda de usuarios/alumnos.
 */

export const initialTypeByCentro = (userOU) =>
  userOU.centro !== 'SUPERADMIN' &&
  userOU.centro !== 'CEDESCA' &&
  userOU.centro !== 'CNTEC' &&
  userOU.centro !== '' &&
  userOU.centro !== 'SEDE' &&
  userOU.centro !== 'SECRETARÍA' &&
  userOU.centro !== 'ORIENTACIÓN'
    ? 'O'
    : 'All';

export const buildParamsByHeadquarter = ({
  headquarter,
  userOU,
  name,
  lastname,
  email,
  dni,
  year,
  cicle,
  course,
  type,
  idUser,
  phone,
  idStripe,
  selectedIds,
  delegaciones,
  deudores,
}) => {
  const base = {
    nombre: name,
    apellido: lastname,
    email,
    dni,
    curs: year,
    grau: cicle,
    cicle: course,
    modalitat: type,
    idccod: idUser,
    phone,
    idStripe,
    documentacion: selectedIds,
  };

  if (
    (userOU.idCedesca === 0 && userOU.idCntec === 0) ||
    (userOU.idCedesca === -1 && userOU.idCntec === -1) ||
    (userOU.idCedesca === -2 && userOU.idCntec === -2) ||
    (userOU.idCedesca === -3 && userOU.idCntec === -3)
  ) {
    return {
      params: { ...base, empresaId: headquarter, nombreDelegacion: delegaciones, deudor: deudores },
      params2: null,
    };
  }

  if (headquarter === 'CEDESCA') {
    return {
      params: { ...base, empresaId: 'CEDESCA', idDelegacio: userOU.idCedesca },
      params2: null,
    };
  }

  if (headquarter === 'CNTEC') {
    return {
      params: { ...base, empresaId: 'CNTEC', idDelegacio: userOU.idCntec },
      params2: null,
    };
  }

  return {
    params: { ...base, empresaId: 'CEDESCA', idDelegacio: userOU.idCedesca },
    params2: { ...base, empresaId: 'CNTEC', idDelegacio: userOU.idCntec },
  };
};

/**
 * Añade la columna de acciones (botón Detalles) a cada fila de resultados.
 * @param {Array} rows - Array de objetos alumno
 * @param {Function} onDetailClick - (id, empresaId) => void
 * @returns {Array} Mismo array con element.actions asignado
 */
export const addActionsToAlumnos = (rows, onDetailClick) => {
  if (!rows || !Array.isArray(rows)) return [];
  rows.forEach((element) => {
    element.actions = (
      <button
        type="button"
        title="Ver detalles"
        aria-label="Detalles"
        onClick={(e) => {
          e.stopPropagation();
          onDetailClick(element.id, element.empresaId);
        }}
        style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          width: '28px', height: '28px', borderRadius: '6px', border: 'none',
          backgroundColor: 'transparent', color: colors.primary, cursor: 'pointer',
        }}
      >
        <ArrowRight size={16} />
      </button>
    );
  });
  return rows;
};
